module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Indice")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003#auto_bookmark_toc_1"
    }
  }, [_vm._v("Sinossi")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_toc_1"
    }
  }, [_vm._v("Anteprima")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_toc_1"
    }
  }, [_vm._v("Prologo")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Uno")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Due")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Tre")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Quattro")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0009#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Cinque")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0010#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Sei")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0011#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Sette")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0012#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Otto")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0013#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Nove")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0014#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Dieci")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0015#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Undici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0016#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Dodici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0017#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Tredici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0018#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Quattordici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0019#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Quindici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0020#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Sedici")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0021#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Diciassette")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0022#auto_bookmark_toc_1"
    }
  }, [_vm._v("Capitolo Diciotto")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0023#auto_bookmark_toc_1"
    }
  }, [_vm._v("Biografia")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0024"
    }
  }, [_vm._v("Visitate il sito di Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0025#auto_bookmark_toc_2"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e473cef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0001.vue
// module id = 57
// module chunks = 0